import React from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import featuredImage from "../../../assets/Baticon.png";
import titleImage from "../../../assets/TitleCommands.png";

const commandSections = [
  {
    title: "ACCESS",
    commands: [
      { command: "/access wallet", description: "Access your wallet." },
      { command: "/access wand", description: "Use magic against another student." },
      { command: "/access weaponry", description: "Use your weaponry on another student." },
      { command: "/access ultimate", description: "Trigger your ultimate." },
      { command: "/access hack", description: "Hack another student." },
      { command: "/access trade", description: "Trade pogs with another student." },
    ],
  },
  {
    title: "SHOP",
    commands: [
      { command: "/shop inventory", description: "View all items available in the shop." },
      { command: "/shop buy", description: "Buy an item from the shop." },
      { command: "/shop sell", description: "Sell an item from the shop." },
    ],
  },
  {
    title: "STATS",
    commands: [
      { command: "/stats cycle", description: "View the current cycle activity." },
      { command: "/stats intel house", description: "View an intel overview of houses." },
      { command: "/stats trends", description: "View Pogforts activity trends." },
      { command: "/stats messages", description: "View the top 20 active users." },
    ],
  },
  {
    title: "CREATE",
    commands: [
      { command: "/create tc", description: "Create a text channel." },
      { command: "/create vc", description: "Create a voice channel." },
      { command: "/create delete", description: "Delete a text or voice channel." },
    ],
  },
  {
    title: "OTHER",
    commands: [
      { command: "/sort", description: "Sort yourself into your house." },
      { command: "/build", description: "Auto-build a professional server." },
      { command: "/interact", description: "Interact with other students." },
      { command: "/mod", description: "Perform moderation tasks." },
      { command: "/invites", description: "View server invites." },
      { command: "/clear", description: "Clear up to 14 days of messages." },
      { command: "/dice", description: "Roll any dice any number of times." },
      { command: "/tarot", description: "Receive a tarot reading." },
      { command: "/help", description: "Classic help command." },
    ],
  },
  {
    title: "ADMIN",
    commands: [
      { command: "/admin search", description: "Admin view of a student." },
      { command: "/admin clear", description: "Clear various selected data." },
      { command: "/admin merits", description: "Add or remove merits." },
      { command: "/admin strikes", description: "Add or remove strikes." },
      { command: "/admin pogs", description: "Add or remove pogs." },
      { command: "/admin house", description: "Change a student's house." },
      { command: "/admin pass", description: "Give or remove a student pass." },
      { command: "/admin rename", description: "Give a student a new name." },
    ],
  },
];

const CommandSection = ({ title, commands }) => (
  <section className="commands-section">
    <div className="commands-section-header">
      <div className="commands-section-kicker">COMMAND GROUP</div>
      <h2 className="commands-section-title">{title}</h2>
    </div>

    <div className="commands-list">
      {commands.map(({ command, description }) => (
        <div className="commands-row" key={command}>
          <code className="commands-code">{command}</code>
          <div className="commands-description">{description}</div>
        </div>
      ))}
    </div>
  </section>
);

const Home = () => {
  const baseURL = window.location.origin;

  return (
    <div className="home-container commands-page">
      <Helmet>
        <title>Magical Sorting Bat - Discord Bot</title>
        <meta name="description" content="The Discord Bot that needs no introduction." />
        <meta property="og:title" content="Magical Sorting Bat - Discord Bot" />
        <meta property="og:description" content="The Discord Bot that needs no introduction." />
        <meta property="og:image" content={`${baseURL}/assets/Baticon.png`} />
        <meta property="og:url" content={`${baseURL}/commands`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Magical Sorting Bat - Discord Bot" />
        <meta name="twitter:description" content="The Discord Bot that needs no introduction." />
        <meta name="twitter:image" content={`${baseURL}/assets/Baticon.png`} />
      </Helmet>

      <h1 className="hidden-title">MSB - Discord Bot Commands</h1>

      <img src={titleImage} alt="TitleCommands" className="featured-image" />
      <img src={featuredImage} alt="Baticon" className="baticon-image" />

      <div className="commands-shell profile-shell">
        <div className="commands-panel profile-panel">
          <div className="commands-topbar profile-topbar">
            <div>

              <h2 className="profile-subtitle">
                Command reference for Pogforts students, locals, and other weird creatures.
              </h2>
            </div>
          </div>

          <div className="commands-sections">
            {commandSections.map((section) => (
              <CommandSection
                key={section.title}
                title={section.title}
                commands={section.commands}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
